import { AxiosRequest } from "../common/axios-request";
import {
  CREATE_RENTING_PRODUCT_STOCK,
  DELETE_RENTING_PRODUCT_DETAILS,
  GET_ALL_RENTING_PRODUCT_STOCK_LIST,
  GET_RENTING_PRODUCT_DETAILS,
  GET_RENTING_PRODUCT_ORDER_HISTORY,
  GET_RENTING_PRODUCT_STOCK_LIST,
  GET_SINGLE_RENTING_PRODUCT_HISTORY,
  UPDATE_RENTING_PRODUCT_DETAILS,
} from "../common/constant";

const GetAllRentingStockList = (id: string, isActive: string = "") => {
  return AxiosRequest.get(GET_ALL_RENTING_PRODUCT_STOCK_LIST(id, isActive));
};

const GetRentingStockList = () => {
  return AxiosRequest.get(GET_RENTING_PRODUCT_STOCK_LIST);
};

const GetRentingProductDetails = (id: string) => {
  return AxiosRequest.get(GET_RENTING_PRODUCT_DETAILS.replace(":id", id));
};

const CreateRentingProduct = (payload: any) => {
  return AxiosRequest.post(CREATE_RENTING_PRODUCT_STOCK, payload);
};

const UpdateRentingProductDetails = (id: string, payload: any) => {
  return AxiosRequest.put(
    UPDATE_RENTING_PRODUCT_DETAILS.replace(":id", id),
    payload
  );
};

const DeleteRentingProduct = (id: string) => {
  return AxiosRequest.delete(DELETE_RENTING_PRODUCT_DETAILS.replace(":id", id));
};

const GetSingleRentingProductHistory = (
  id: string,
  year: string,
  month: string
) => {
  return AxiosRequest.get(GET_SINGLE_RENTING_PRODUCT_HISTORY(id, year, month));
};

const GetRentingProductOrderHistory = (id: string, year: string, month: string) => {
  return AxiosRequest.get(GET_RENTING_PRODUCT_ORDER_HISTORY(id, year, month))
}

export {
  GetAllRentingStockList,
  GetRentingStockList,
  GetRentingProductDetails,
  CreateRentingProduct,
  UpdateRentingProductDetails,
  DeleteRentingProduct,
  GetSingleRentingProductHistory,
  GetRentingProductOrderHistory
};
